import React from 'react';
import PropTypes from 'prop-types';




const PaymentBlankTag = ({boxType, color, text }) => {
  let backgroundStyle = {
    background : color
  };
  return (
      <span className={boxType === 'circle' ? 'calc-payment-fts-tag' : 'calc-payment-tag '} style={backgroundStyle}>{text}</span>
  );
};

PaymentBlankTag.propTypes = {
  boxType: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string,
};

export default PaymentBlankTag;

